"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlanKind = void 0;
/**
 * Types of query plans.
 *
 * @public
 */
var PlanKind;
(function (PlanKind) {
    /**
     * The specified action is always allowed for the principal on resources matching the input.
     */
    PlanKind["ALWAYS_ALLOWED"] = "KIND_ALWAYS_ALLOWED";
    /**
     * The specified action is always denied for the principal on resources matching the input.
     */
    PlanKind["ALWAYS_DENIED"] = "KIND_ALWAYS_DENIED";
    /**
     * The specified action is conditionally allowed for the principal on resources matching the input.
     */
    PlanKind["CONDITIONAL"] = "KIND_CONDITIONAL";
})(PlanKind || (exports.PlanKind = PlanKind = {}));
//# sourceMappingURL=PlanKind.js.map